// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { DataCacheToolType } from '../DataCacheToolEnums';
import { BaseFibonacciDataCacheTool } from './BaseFibonacciDataCacheTool';
import { DynProperty } from '../../DynProperty';
export class FibonacciEllipseDataCacheTool extends BaseFibonacciDataCacheTool {
    /**
     * Constructor for FibonacciEllipseDataCacheTool
     */
    constructor() {
        super();
        this.ToolType = DataCacheToolType.FibonacciEllipse;
        this.InitPoints(2);
    }
    /**
     * Initializes the block for the tool
     */
    InitBlock() {
        super.InitBlock();
        this.fibLevel = [61.8, 100, 161.8];
    }
    /**
     * Gets the maximum points count required for the tool
     * @returns {number} - Maximum points count
     */
    MaxPointsCount() {
        return 2;
    }
    /**
     * Gets the minimum points count required for the tool
     * @returns {number} - Minimum points count
     */
    MinPointsCount() {
        return 2;
    }
    /**
     * Properties for FibonacciEllipseDataCacheTool
     * @returns {DynProperty[]} - Array of dynamic properties
     */
    Properties() {
        const props = super.Properties();
        let prop = new DynProperty(Resources.getResource('EnableNegativeFibonacciValue'), false, DynProperty.BOOLEAN, DynProperty.FIBONACCI_PARAMETERS_GROUP);
        props.push(prop);
        prop = new DynProperty('chart.tools.fibretr.fontcolor', this.FontColor, DynProperty.COLOR, DynProperty.VISUAL_GROUP);
        props.push(prop);
        return props;
    }
    /**
     * Callback function for handling dynamic property changes
     * @param {DynProperty[]} properties - Array of dynamic properties
     */
    callBack(properties) {
        super.callBack(properties);
        const prop = DynProperty.getPropertyByName(properties, 'chart.tools.fibretr.fontcolor');
        if (prop != null)
            this.FontColor = prop.value;
    }
}
